import React, { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import IllustratedMessageUpload from './IllustratedMessageUpload'
import DropZone from '@react/react-spectrum/DropZone'
import Button from '@react/react-spectrum/Button'
import ModalTrigger from '@react/react-spectrum/ModalTrigger'
import Dialog from '@react/react-spectrum/Dialog'
import Link from '../Nav/Link'
import Title from './Title'
import DownloadFile from './DownloadFile'
import {
    logAlert,
    logWarning,
    logSuccess,
    getFilenameWithoutExt,
    capitalizeFirstLetter,
    uploadAssetFile,
    createRecaptchaElement,
    getFileSize,
    isValidFileSize,
    isValidFileType,
    getAperitif,
    getAperitifToken,
    getAperitifStorage,
    getUtStorage,
    getPutUrl,
    getExpectedFileSizeToUpload,
    clickElement,
    logMsg,
    getStartedUrl
} from '../../lib/easybake'
import { 
    STATUS_CODE_FAIL_FORBIDDEN,
    STATUS_CODE_FAIL_UNAUTHORIZED
} from '../../lib/constants'

export default function UploadAsset (props) {
    const { ut, dispatch, page, customFiles, aperitif, utStorage } = useContext(EasybakeContext)
    const { assetType, imageType } = props || {}
    if (!ut) {
        createRecaptchaElement()
    }

    async function uploadFile(e, assetType) {
        try {
            e.preventDefault()
            e.stopPropagation()
            const startDate = new Date()
            let fileList = null
            if (e.target && e.target.files) {
                analytics.sendEventName('click', `${page}:upload`)
                fileList = e.target.files
            } else {
                if (e.dataTransfer.files.length > 1) {
                    logWarning(__('msg_error_drag_drop_no_multiple_files'))
                    return
                }
                analytics.sendEventName('drag', `${page}:upload`)
                fileList = e.dataTransfer.files
            }
            for (var i = 0; i < fileList.length; i++) {
                const selectedFile = fileList[i]
                const expectedFileSize = getExpectedFileSizeToUpload(assetType)
                if (!isValidFileSize(selectedFile.size, expectedFileSize)) {
                    logWarning(`${selectedFile.name} is too large (${getFileSize(selectedFile.size)}). ${__('max_file_size_is')} ${getFileSize(expectedFileSize)}.`)
                    return
                }
                var fileReader = new FileReader()
                fileReader.onloadend = async (e) => {
                        try {
                        const isValidFileTypeRes = isValidFileType(e.target.result, assetType, assetType==='image'?['image/png','image/jpeg','image/jpg']:['application/octet-stream'])
                        if(isValidFileTypeRes !== true) {
                            logWarning(isValidFileTypeRes)
                            return
                        }
                        let tempOutputs //TODO
                        if (ut) {
                            if (!utStorage) {
                                const getUtStorageResult = await getUtStorage(3, ut)
                                if (getUtStorageResult.error) {
                                    analytics.sendEventName('api', 'utStorage:fail')
                                    logAlert(null, getUtStorageResult.e.message)
                                    postUpload(null, null, null, startDate)
                                    return
                                }
                                const { outputs } = await getUtStorageResult.response.json();
                                analytics.sendEventName('api', `utStorage:${getUtStorageResult.response.status}`)
                                if (getUtStorageResult.response.status === STATUS_CODE_FAIL_FORBIDDEN || getUtStorageResult.response.status === STATUS_CODE_FAIL_UNAUTHORIZED || !outputs) {
                                    clickElement('btnShowTempOutputsError')
                                    return
                                } else {
                                    tempOutputs = outputs
                                    dispatch({ type: 'set-utStorage', payload: {utStorage: tempOutputs} })
                                }
                            }
                        } else {
                            if (!aperitif) {
                                const getAperitifTokenResult = await getAperitifToken()
                                if (getAperitifTokenResult.error) {
                                    analytics.sendEventName('api', 'aperitif/token:fail')
                                    const errMsg = (getAperitifTokenResult.response && getAperitifTokenResult.response.status ? `${getAperitifTokenResult.response.status}: ${getAperitifTokenResult.response.statusText}` : getAperitifTokenResult.e && getAperitifTokenResult.e.message) || 'Unknown'
                                    logAlert(null, errMsg)
                                    postUpload(null, null, null, startDate)
                                    return
                                }
                                const { outputs } = await getAperitifTokenResult.response.json();
                                const getAperitifStorageResult = await getAperitifStorage(3, outputs)
                                if (getAperitifStorageResult.error) {
                                    analytics.sendEventName('api', 'aperitif/storage:fail')
                                    const errMsg = (getAperitifStorageResult.response && getAperitifStorageResult.response.status ? `${getAperitifStorageResult.response.status}: ${getAperitifStorageResult.response.statusText}` : getAperitifStorageResult.e && getAperitifStorageResult.e.message) || 'Unknown'
                                    logAlert(null, errMsg)
                                    postUpload(null, null, null, startDate)
                                    return
                                }
                                const getAperitifStorageResponse = await getAperitifStorageResult.response.json();
                                analytics.sendEventName('api', `aperitif:${getAperitifStorageResult.response.status}`)
                                if (getAperitifStorageResult.response.status === STATUS_CODE_FAIL_FORBIDDEN || getAperitifStorageResult.response.status === STATUS_CODE_FAIL_UNAUTHORIZED || !outputs) {
                                    clickElement('btnShowTempOutputsError')
                                    return
                                } else {
                                    tempOutputs = getAperitifStorageResponse.outputs
                                    tempOutputs.userToken = outputs.userToken
                                    dispatch({ type: 'set-aperitif', payload: {aperitif: tempOutputs} })
                                }
                            }
                        }
                        dispatch({ type: 'wait', payload: true })
                        dispatch({ type: 'set-uploadProgress', payload: {uploadProgress: 0} })

                        let assetNum = 0 //input image file
                        if (assetType === 'action') {
                            assetNum = 1
                        }
                        const putUrlResponse = await getPutUrl(aperitif || utStorage || tempOutputs, assetNum)
                        if (putUrlResponse.error) {
                            analytics.sendEventName('api', 'getPutUrl:fail')
                            logAlert(null, putUrlResponse.msg)
                            postUpload(null, null, null, startDate)
                            return
                        }
                        const uploadedFile = {
                            tempUrls: putUrlResponse.url,
                            name: selectedFile.name,
                            storage: 'external',
                            shortName: getFilenameWithoutExt(selectedFile.name),
                            type: selectedFile.name.split('.').pop(),
                            size: selectedFile.size,
                            url: selectedFile.url || putUrlResponse.url,
                            thumbnail: URL.createObjectURL([...fileList].filter( f => f.name === selectedFile.name)[0]),
                            assetType: assetType
                        }
                        const formData = new FormData()
                        formData.append('file', selectedFile)
                        const opts = {
                            config: {
                                timeout: 30000,
                                onUploadProgress: (e) => {
                                    const currentProgress = (parseInt(e.loaded) / parseInt(e.total) * 100).toFixed(0)
                                    dispatch({ type: 'set-uploadProgress', payload: {uploadProgress: currentProgress} })
                                    if (currentProgress === "100") {
                                        logSuccess(`${capitalizeFirstLetter(assetType)} ${__('uploaded_success')}`)
                                        dispatch({ type: 'upload', payload: false })
                                    }
                                }
                            },
                            data: selectedFile
                        }
                        await uploadAssetFile(page, putUrlResponse.url.put, opts, (response, err) => {
                            if (response) {
                                postUpload(response, customFiles, uploadedFile, startDate)
                            } else {
                                postUpload(null, null, uploadedFile, startDate)
                                logAlert(null, err)
                            }
                        })
                    } catch(e) {
                        postUpload(null, null, null, startDate)
                        logAlert(e)
                    }
                }
                fileReader.readAsArrayBuffer(selectedFile);
            }
        } catch(e) {
            logAlert(e)
        }
    }

    function postUpload(response, customFiles, uploadedFile, startDate) {
        try {
            let newCustomFiles = []
            if (customFiles) {
                newCustomFiles = JSON.parse(JSON.stringify(customFiles))
                newCustomFiles.push(uploadedFile)
            } else {
                dispatch({ type: 'set-aperitif', payload: { aperitif: null } }) //error case
                dispatch({ type: 'set-utStorage', payload: { utStorage: null } }) //error case
            }
            dispatch({ type: 'set-customFiles', payload: { customFiles: newCustomFiles } })
            dispatch({ type: 'wait', payload: false })
            dispatch({ type: 'upload', payload: false })

            const endDate = new Date()
            var seconds = Math.round((endDate.getTime() - startDate.getTime()) / 1000)
            logMsg(null, `${page}:upload:seconds:${seconds}`)
            analytics.sendEvent(
                {
                    type: 'api',
                    action: 'upload',
                    file: uploadedFile,
                    page: page,
                    storage: `${ut ? 'utStorage' : 'aperitif'}`,
                    response: response ? response.status : 'unknown',
                    elapsedTime: seconds
                }
            )
            if (uploadedFile) {
                analytics.sendEventName('upload', `${uploadedFile.type}:size:${analytics.getFileSizeInMb(uploadedFile.size)}`)
                analytics.sendEventName('upload', `${uploadedFile.type}:elapsedTime:${analytics.getElapsedTime(seconds)}`)
                analytics.sendEventName('upload', `${uploadedFile.type}:response:${response ? response.status : 'unknown'}`)
                analytics.sendEventName('upload', `${uploadedFile.type}:storage:${ut ? 'utStorage' : 'aperitif'}`)
            }
        } catch(e) {
            logAlert(e)
        }
    }

    function go (e, referrer) {
        switch (e) {
            case 'secondary':
                if (window.easybake) {
                    window.easybake.parent.signIn()
                }
                break;
            default:
                analytics.sendEventName('signup', `${referrer}:limitexceeded`)
                if (window.easybake && window.easybake.parent) {
                    window.easybake.parent.setURL(getStartedUrl())
                } else {
                    dispatch({ type: 'set-page', payload: { page: 'signup' } })
                }
                break;
        }
    }

    function cancel(e) {
        analytics.sendEventName('click', `${page}:upload:cancel`)
        dispatch({ type: 'set-page', payload: { page } })
    }

    return <div className="adobe-easybake-main-pane-upload">
        <div className="adobe-easybake-upload-asset-div">
            <ModalTrigger>
                <div className="adobe-easybake-hide">
                <Button id="btnShowTempOutputsError" quiet 
                    variant="secondary" 
                    modalTrigger></Button>
                </div>
                <Dialog
                    onConfirm={e => go(e, page)}
                    modalContent
                    title={__('console_get_started_title')}
                    confirmLabel={__('nav_signup')}
                    secondaryLabel="Sign in"
                    size="S"
                    keyboardConfirm
                    cancelLabel={__('btn_cancel')}>
                    {__('max_play_time_reached')}
                </Dialog>
            </ModalTrigger>
            <br />
            <div className="adobe-easybake-row-title">
                <div>
                    <Title title={`Choose an ${assetType} ${ assetType === "image" ? "(.jpg, .png)" : "(.atn)"} to upload (Maximum file size is ${ assetType === "image" ? "10 MB" : "1 MB"})`} />
                </div>
                <div>
                    { assetType === 'action' ? <Link className="adobe-easybake-nav-link" referrer={`${page}:whatisaction`} label={__('whatthis')} url={__('url_helpx_psactions')} noBreak={true} /> : null }
                </div>
            </div>
            <br />
            <div onClick={ e => clickElement('inputUpload') } >
                <DropZone
                    className="adobe-easybake-custom-files-drop-zone-upload"
                    dropEffect="copy"
                    onDrop={e => uploadFile(e, assetType)}>
                    <IllustratedMessageUpload />
                    <input type="file"
                        name="file"
                        id="inputUpload"
                        className="adobe-easybake-hide"
                        accept={ imageType }
                        onChange={ e => uploadFile(e, assetType) } 
                        onClick={(e) => { e.target.value = ''}}/>
                </DropZone>
            </div>
            <br />
            <div className="adobe-easybake-flex-row-button-right-aligned">
                <Button variant="primary" onClick={ e => cancel(e) }>{__('btn_cancel')}</Button>
                <Button quiet variant="cta" disabled>{__('btn_continue')}</Button>
            </div>
        </div>
    </div>
}
